module.exports = __webpack_public_path__ + "img/check-list.6622e9ca.png";